<template>
  <div id="songloader-container">
    <v-card class="theme-bg-card-2">
      <v-flex>
      <v-card-title>

      </v-card-title>
      <v-card-text>
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Artist</th>
              <th>Duration</th>
              <th>BPM</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(song, index) in songs" :key="index" @click="selectSong(song)">
              <td>{{ song.title }}</td>
              <td>{{ song.artist }}</td>
              <td>{{ song.duration }}</td>
              <td>{{ song.bpm }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
      </v-flex>
    </v-card>
    <section id="songloader">
      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Artist</th>
            <th>Duration</th>
            <th>BPM</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(song, index) in songs" :key="index" @click="selectSong(song)">
            <td>{{ song.title }}</td>
            <td>{{ song.artist }}</td>
            <td>{{ song.duration }}</td>
            <td>{{ song.bpm }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDeck: 'deck1', // You can change this based on your application's logic
      deck1: null, // Initially, no song is loaded
      deck2: null,  // Initially, no song is loaded
      songs: [ // List of songs
        {
          title: 'Push [Mak & Pasteman Remix]',
          artist: 'A-Trak feat. Andrew Wyatt',
          duration: '06:59',
          bpm: 126,
          audio: new Audio('http://www.michelacosta.com/html5/push.mp3')
        },
        {
          title: 'Royston',
          artist: 'Artist Name',
          duration: '05:30',
          bpm: 128,
          audio: new Audio('http://www.michelacosta.com/html5/royston.mp3')
        },
        {
          title: 'Ragga',
          artist: 'Artist Name',
          duration: '04:45',
          bpm: 132,
          audio: new Audio('http://www.michelacosta.com/html5/ragga.mp3')
        },
        {
          title: 'Showtek',
          artist: 'Artist Name',
          duration: '03:50',
          bpm: 124,
          audio: new Audio('http://www.michelacosta.com/html5/showtek.mp3')
        }
      ]
    };
  },
  methods: {
    selectSong(song) {
      console.log(`Loading song: ${song.title} by ${song.artist}`);
      
      // Example logic to load the song into the appropriate deck
      if (this.currentDeck === 'deck1') {
        this.deck1 = song;
        this.loadIntoDeck1(song);
      } else if (this.currentDeck === 'deck2') {
        this.deck2 = song;
        this.loadIntoDeck2(song);
      }
      
      // Optionally, you can switch the deck after loading the song
      this.switchDeck();
    },
    
    loadIntoDeck1(song) {
      // Implement the logic to load the song into deck 1
      console.log(`Loading ${song.title} into Deck 1`);
      if (this.deck1) {
        this.deck1.audio.pause();
      }
      this.deck1.audio = song.audio;
      this.deck1.audio.play();
    },
    
    loadIntoDeck2(song) {
      // Implement the logic to load the song into deck 2
      console.log(`Loading ${song.title} into Deck 2`);
      if (this.deck2) {
        this.deck2.audio.pause();
      }
      this.deck2.audio = song.audio;
      this.deck2.audio.play();
    },
    
    switchDeck() {
      // Logic to switch the current deck
      this.currentDeck = this.currentDeck === 'deck1' ? 'deck2' : 'deck1';
      console.log(`Switched to ${this.currentDeck}`);
    }
  }
};
</script>

<style scoped>
#songloader-container {
  position: sticky;
  max-width: 900px;
  max-height: 500px;
  margin: 10px 10px 10px 10px;
  background-color: #1c1c1e;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-family: Arial, sans-serif;
  scroll-behavior: auto;
}

#songloader table {
  position: absolute;
  width: 100%;
  padding-block: 10px;
  border-collapse: collapse;
  margin-bottom: -100px;
}

#songloader th {
  background-color: #2c2c2e;
  padding: 15px;
  text-align: left;
  font-size: 14px;
  color: #a6a6a6;
  text-transform: uppercase;
}

#songloader td {
  padding: 12px 15px;
  border-bottom: 1px solid #3a3a3c;
  font-size: 14px;
}

#songloader tr {
  cursor: pointer;
  transition: background-color 0.3s;
}

#songloader tr:hover {
  background-color: #3a3a3c;
}

#songloader tr:nth-child(even) {
  background-color: #2a2a2c;
}

#songloader tr:active {
  background-color: #575759;
}

</style>
